import http from "@web-app/utils/http";

export type OfferInfo = {
  distanceKm: number;
  driverId: string;
  driverName: string;
  expiresAt: string;
  requestId: string;
};

export type AutoAssignResponse = {
  activeOffer?: OfferInfo | null;
  assignedDriver?: {
    distanceKm: number;
    driverId: string;
    name: string;
  } | null;
  requestId: string;
  status: string;
};

export const initiateOrderAutoAssign = (orderId: string) => {
  return http
    .post<AutoAssignResponse>(`/orders/${orderId}/auto-assign`)
    .then((response) => response.data);
};

export const initiateRouteAutoAssign = (routeId: string) => {
  return http
    .post<AutoAssignResponse>(`/routes/${routeId}/auto-assign`)
    .then((response) => response.data);
};

export const getAutoAssignSearchingIds = (entityIds: string[]) => {
  return http
    .post<{ entityIds: string[] }>("/auto-assign/searching", { entityIds })
    .then((response) => response.data);
};
